import { gql } from '@apollo/client';

export const GET_INHUB_SORTING_ACCOUNT_SUMMARIES_PAGE = gql`
  query GetInhubSortingAccountSummariesPage($filter: InhubSortingAccountPageInput!) {
    getInhubSortingAccountSummariesPage(filter: $filter) {
      content {
        accountId
        accountName
        laborTeamId
        laborTeamName
        accountCount
        inboundCount
        baggingCount
        loadingParcelCount
        wrongRouteBaggingCount
        wrongSortCount
        ascanMissCount
        transitInMissCount
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export type InhubSortingAccountOrderField =
    | 'ACCOUNT_NAME'
    | 'LABOR_TEAM_NAME'
    | 'ACCOUNT_COUNT'
    | 'INBOUND_COUNT'
    | 'BAGGING_COUNT'
    | 'LOADING_PARCEL_COUNT'
    | 'WRONG_ROUTE_BAGGING_COUNT'
    | 'WRONG_SORT_COUNT'
    | 'ASCAN_MISS_COUNT'
    | 'TRANSIT_IN_MISS_COUNT';

export type SortDirection = 'ASC' | 'DESC';

export type InhubSortingDimension = 'TEAM' | 'ACCOUNT';

export interface InhubSortingAccountPageInput {
    hubId: number;
    rangeStart: string;
    rangeEnd: string;
    page: number;
    pageSize: number;
    orderBy?: InhubSortingAccountOrderField;
    orderDir?: SortDirection;
    dimension?: InhubSortingDimension;
}

export interface InhubSortingAccountRowResp {
    accountId: number;
    accountName: string;
    laborTeamId: number | null;
    laborTeamName: string;
    accountCount: number;
    inboundCount: number;
    baggingCount: number;
    loadingParcelCount: number;
    wrongRouteBaggingCount: number;
    wrongSortCount: number;
    ascanMissCount: number;
    transitInMissCount: number;
}

export interface GetInhubSortingAccountSummariesPageResponse {
    getInhubSortingAccountSummariesPage: {
        content: InhubSortingAccountRowResp[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}
